import SectionCard from "./AccounSettingSectionCard";

const Placeholder = ({ title, message }) => (
  <SectionCard title={title}>
    <p className="text-secondary-500">{message} This feature is coming soon.</p>
  </SectionCard>
);

export default Placeholder;